import React from 'react';
import { Dialog } from "primereact/dialog";
import { Button } from 'reactstrap';
import Select from 'react-select';
// import './styleTransfer.css';
import { SearchAsync } from '../../../components/elements/SearchAsync';

export const DialogTransferPatient = ({
    modalTransfer, closeTransferPatient,
    handleInputChange,
    handleCreateTransferPatient,
    showConfirm, setShowConfirm,
    setIsPatientSelected, isPatientSelected, setSearchPatientState, searchPatientState, formValuesPatient, handleSelectChangePatient,
    searchKey, setSearchKey,

    handleShowConfirmPatient, getWorkOrderPatientCount, handleTransferPatient,
    errorTransferPatient, workOrderPatientCount, namePatientDestination, namePatientOrigin,
    setSearchPatientDestination, searchPatientDestination, setSearchPatientOrigin, searchPatientOrigin, loadingCount


}) => {

    const footer = (
        <div className='mt-2' style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>

            {showConfirm ? (
                <>
                    <Button
                        color="secondary"
                        size="sm"
                        onClick={handleTransferPatient}
                        disabled={workOrderPatientCount === 0}
                    >

                        Sí, confirmar
                    </Button>

                    <Button
                        color="danger"
                        size="sm"
                        onClick={closeTransferPatient}
                    >
                        Cancelar
                    </Button>

                </>
            ) : (
                <>


                    <Button
                        color="secondary"
                        size="sm"
                        onClick={handleShowConfirmPatient}
                    >
                        Confirmar transferencia
                    </Button>
                    <Button
                        color="danger"
                        size="sm"
                        onClick={closeTransferPatient}
                    >
                        Cancelar
                    </Button>
                </>
            )}

        </div>
    );


    const ordenText =
        workOrderPatientCount === 1
            ? "1 orden de trabajo"
            : `${workOrderPatientCount} órdenes de trabajo`;

    const verb =
        workOrderPatientCount === 1
            ? "tiene asignada"
            : "tiene asignadas";

    const transferText =
        workOrderPatientCount === 1
            ? "transferir la orden de trabajo"
            : "transferir las órdenes de trabajo";



    return (
        <Dialog
            visible={modalTransfer}
            onHide={closeTransferPatient}
            modal
            closable={false}
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="fa fa-child f-24"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                Homologar pacientes
                            </div>


                        </div>

                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v2`}
            footer={footer}
        >

            <div className="transfer-container">
                <div className="transfer-card">
                    <small>Paciente de origen</small>
                    <div className="search-top-layer">

                        <SearchAsync
                            name="id_patient_origin"
                            method={(option) => {
                                handleSelectChangePatient(option, "origin");
                            }}
                            loincState={searchPatientOrigin}
                            setLoincState={(value) => {
                                setSearchPatientOrigin(value);
                            }}
                            url="Patient/SearchPatient"
                            placeholder='Búsqueda por nombre o curp'
                        />
                    </div>
                    {errorTransferPatient.origin && (
                        <div style={{
                            marginTop: "12px",
                            padding: "10px 12px",
                            borderRadius: "8px",
                            background: "#fff1f2",
                            color: "#b91c1c",
                            fontSize: "13px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px"
                        }}>
                            <i className="pi pi-info-circle"></i>
                            {errorTransferPatient.origin}

                        </div>
                    )}


                </div>

                <div className="arrow-transfer">
                    <i className="pi pi-arrow-down"></i>
                </div>

                <div className="transfer-card">
                    <small>Paciente destino</small>
                    <div style={{
                        border: !isPatientSelected ? "1px solid #f04438" : "1px solid #ffffff",
                        borderRadius: "8px",
                        padding: "2px"
                    }}>

                        <div className="search-top-layer">

                            <SearchAsync
                                name="id_patient_destination"
                                method={(option) => {
                                    handleSelectChangePatient(option, "destination");
                                }}
                                loincState={searchPatientDestination}
                                // setLoincState={setSearchPatientDestination}
                                setLoincState={(value) => {
                                    setSearchPatientDestination(value);
                                }}
                                url="Patient/SearchPatient"
                                placeholder='Búsqueda por nombre o curp'
                            />


                        </div>


                        {/* </div> */}

                        {errorTransferPatient.destiny && (
                            <div style={{
                                marginTop: "12px",
                                padding: "10px 12px",
                                borderRadius: "8px",
                                background: "#fff1f2",
                                color: "#b91c1c",
                                fontSize: "13px",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px"
                            }}>
                                <i className="pi pi-info-circle"></i>
                                {errorTransferPatient.destiny}
                            </div>
                        )}

                    </div>

                    {showConfirm && workOrderPatientCount !== null && (
                        <div className={`security-box ${workOrderPatientCount === 0 ? "warning-yellow" : "warning"} mt-3`}>
                            <div className="security-icon">
                                <i className="pi pi-exclamation-triangle"></i>
                            </div>

                            <div className="security-content">
                                <strong className='mr-2'>
                                    {workOrderPatientCount === 0 ? "Sin órdenes" : "Advertencia"}
                                </strong>

                                <p>
                                    {workOrderPatientCount === 0 ? (
                                        <>
                                            El paciente <b>{namePatientOrigin}</b> no tiene órdenes de trabajo.
                                            <br /><br />
                                            <b>Selecciona otro paciente.</b>
                                        </>
                                    ) : (
                                        <>
                                            El paciente <b>{namePatientOrigin}</b> {verb} <b>{ordenText}</b>.
                                            <br /><br />

                                            ¿Estás seguro que deseas {transferText} al paciente{" "}
                                            <b>{namePatientDestination}</b>?
                                            <br /><br />

                                            <span style={{ color: "#b91c1c", fontWeight: "600" }}>
                                                Esta acción no se puede deshacer.
                                            </span>
                                        </>
                                    )}
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            </div>

        </Dialog>
    );
};